<template>
    <v-container style="padding-top: 80px !important">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Búsqueda</p>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row class="text-left" v-if="permisoAlta">
                        <v-btn style="margin-top: 25px !important; margin-left: 25px !important; " class="ma-2"
                            color="success" title="Nueva Fianza"
                            @click="$router.push({ name: 'AltaFianzas' }).catch((error) => error);">
                            <span style="color: white">Nueva Fianza</span>
                        </v-btn>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="8" md="8">
                            <label class="typo__label" style="text-align: center;">Folio:</label>
                            <v-text-field v-model="datosBusqueda.folio"
                                v-on:blur="datosBusqueda.folio = datosBusqueda.folio != null ? datosBusqueda.folio.trim() : null"
                                outlined :error-messages="validation.folio" maxlength="30" dense
                                @keypress="validarRegex($event, 'NL')">
                            </v-text-field>
                            <v-divider class="my-2"></v-divider>
                            <label class="typo__label" style="text-align: center;">Afianzadora:</label>
                            <multiselect v-model="datosBusqueda.afianzadora"
                                deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                select-label="Seleccionar valor" track-by="afclave" label="afnombre"
                                placeholder="Seleccionar Cliente" :options="afianzadorasArray" :allow-empty="true">
                            </multiselect>
                            <v-divider class="my-4"></v-divider>
                            <label class="typo__label" style="text-align: center;">Responsable:</label>
                            <multiselect v-model="datosBusqueda.responsable"
                                deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                select-label="Seleccionar valor" track-by="usuario" label="nombre"
                                placeholder="Seleccionar Responsable" :options="responsablesArray" :allow-empty="true">
                            </multiselect>
                            <v-divider class="my-4"></v-divider>
                            <label class="typo__label" style="text-align: center;">Estatus:</label>
                            <multiselect v-model="datosBusqueda.estatus"
                                deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                select-label="Seleccionar valor" track-by="fiestatus" label="fiestatus"
                                placeholder="Seleccionar estatus" :options="estatusArray" :allow-empty="true">
                            </multiselect>
                            <span v-if="showAlert" style="color: #FF5C93;"> Debes seleccionar al menos un criterio de
                                búsqueda
                            </span>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-card-actions>
                            <v-btn class="ma-2" color="primary" title="Guardar" @click="BuscarDatos(1)"
                                :loading="loading">
                                <span style="color: white">Buscar</span>
                            </v-btn>
                            <v-btn class="ma-2" color="default" v-on:click="limpiar()">
                                <span>Limpiar</span>
                            </v-btn>
                            <v-btn class="ma-2" color="secondary" v-on:click="Cancelar()">
                                <span>Cancelar</span>
                            </v-btn>
                        </v-card-actions>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Resultados</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <v-row v-if="showTable" justify="center">
                    <v-col cols="12">
                        <DataTable :url="urlHistorial" :columns="columns" :params="displayInputs" :order="[]"
                            select="single" @input="IrDetalleFianza" @apiDT="apiDT = $event" class="tablaFianzas"
                            :dom="`<'row'<'col-sm-12 align-content:left'f>><'row'<'col-sm-12'tr >>`" :paging="false">
                        </DataTable>
                    </v-col>
                </v-row>
                <div v-if="showTable">
                    <template>
                        <v-row>
                            <v-col cols="12" md="6" sm="12">
                                <div class="ml-2 text-center select-registros">
                                    <label>Mostrar </label>
                                    <v-select v-model="numreg" :items="regpagina" style="max-width: 60px"
                                        class="ml-2 my-custom-select" name="numreg" id="numreg" dense></v-select>
                                    <label>registros</label>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <div class="pt-2 div-paginacion">
                                    <v-pagination v-model="pagina" prev-icon="mdi-chevron-double-left"
                                        next-icon="mdi-chevron-double-right" :length="numpaginas" :total-visible="5"
                                        name="pagina" id="pagina" @input="onPageChange">
                                    </v-pagination>
                                </div>
                            </v-col>
                        </v-row>
                    </template>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>

import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
import Fianzas from '@/services/Fianzas/fianzas.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            urlHistorial: "Fianzas/BusquedaFianzas",
            displayInputs: {
                folio: null,
                responsable: null,
                estatus: null,
                afianzadora: null,
                numPag: 1,
                numReg: 20,
            },
            apiDT: null,
            columns: [
                { name: 'fifolio', data: 'fifolio', title: "Folio", },
                { name: 'afnombre', data: 'afnombre', title: "Afianzadora", },
                { name: 'nrreporte', data: 'nrreporte', title: "Reporte" },
                { name: 'svindice', data: 'svindice', title: "Indice" },
                { name: 'fiimporte', data: 'fiimporte', title: "Importe" },
                { name: 'fiprima', data: 'fiprima', title: "Prima" },
                { name: 'ufalias', data: 'ufalias', title: "Responsable" },
            ],
            datosBusqueda: {
                folio: '',
                afianzadora: null,
                responsable: null,
                estatus: null,
            },
            validForm: true,
            showTable: false,
            showcargando: true,
            validation: {
                folio: '',
            },
            afianzadorasArray: [],
            responsablesArray: [],
            estatusArray: [],
            showAlert: false,
            permisoContraloria: false,
            permisoFianzas: false,
            permisoAlta: false,
            numreg: 20,
            regpagina: [20, 50, 100,],
            pagina: 1,
            numpaginas: 0,
            numpag: 1,
            loading: false,
        }
    },
    watch: {
        'datosBusqueda.folio'(val) {
            if (this.datosBusqueda.folio != null && this.datosBusqueda.folio != '') {
                this.displayInputs.numPag = 1;
                this.showAlert = false;
            }
        },
        'datosBusqueda.afianzadora'(val) {
            if (this.datosBusqueda.afianzadora != null) {
                this.showAlert = false;
            }
        },
        'datosBusqueda.responsable'(val) {
            if (val != null) {
                this.showAlert = false;
            }
        },
        'datosBusqueda.estatus'(val) {
            if (this.datosBusqueda.estatus != null) {
                this.showAlert = false;
            }
        },
        async numreg(nuevoValor) {
            this.numreg = nuevoValor;
            this.numpag = 1;
            this.pagina = 1;
            this.numpaginas = 1;

            await this.BuscarDatos(2);
        }
    },
    computed: {
        ...mapState(["domain"]),
    },
    methods: {
        validarRegex(evt, tipo) {
            return MetodosGenerales.validarRegex(evt, tipo);
        },
        Cancelar() {
            this.$router.push({ name: "MenuRecuperaciones" });
        },
        limpiar() {
            this.showTable = false;
            this.datosBusqueda.folio = null;
            this.datosBusqueda.responsable = null;
            this.datosBusqueda.estatus = null;
            this.datosBusqueda.afianzadora = null;
            this.showAlert = false;
        },
        async BuscarDatos(tipo) {
            this.showTable = false;
            this.loading = true;
            this.displayInputs.folio = null;
            this.displayInputs.responsable = null;
            this.displayInputs.estatus = null;
            this.displayInputs.afianzadora = null;

            var counter = 0;
            if (this.datosBusqueda.folio != null && this.datosBusqueda.folio != '') {
                this.displayInputs.folio = this.datosBusqueda.folio;
                counter++;
            }
            if (this.datosBusqueda.afianzadora != null) {
                this.displayInputs.afianzadora = this.datosBusqueda.afianzadora.afclave;
                counter++;
            }
            if (this.datosBusqueda.responsable != null) {
                this.displayInputs.responsable = this.datosBusqueda.responsable.usuario;
                counter++;
            }
            if (this.datosBusqueda.estatus != null) {
                this.displayInputs.estatus = this.datosBusqueda.estatus.fiestatus;
                counter++;
            }
            if (counter == 0) {
                this.showAlert = true;
            } else {
                this.displayInputs.numReg = this.numreg;
                this.displayInputs.numPag = tipo == 1 ? 1 : this.numpag;
                var numpag = await Fianzas.BusquedaFianzasTam(this.displayInputs);
                this.numpaginas = numpag;
                await this.reloadTable();
                this.showTable = true;
            }
            this.loading = false;
        },
        async reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        async IrDetalleFianza(datos) {
            await MetodosGenerales.guardarEnSesionInfoReporte(datos, 'fianza');
            this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
        },
        async onPageChange() {
            this.numpag = this.pagina;
            await this.BuscarDatos(3);
        },

    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "15,16,317").then((response) => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 15)//acceso al módulo de contraloría Normativa 
                        this.permisoContraloria = true;
                    if (permiso.peclave == 16)//acceso a alta fianza
                        this.permisoAlta = true;
                    if (permiso.peclave == 317)//Permiso para fianzas
                        this.permisoFianzas = true;
                })

                if (!this.permisoContraloria || !this.permisoFianzas) {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });
    },
    async mounted() {
        this.afianzadorasArray = await Fianzas.ObtenerAfianzadoras();
        this.responsablesArray = await Fianzas.ObtenerResponsables();
        this.estatusArray = await Fianzas.ObtenerEstatus();
        this.showcargando = false;
    },
}
</script>
<style scoped>
.tablaFianzas {
    cursor: pointer;
}
</style>